import t from "../locales/translation";
import CustomButton from "./CustomButton";
import { DefaultPackageColProps } from "../models/PropsInterface";
import "../cssStyles/DefaultPackageCol.css";

const DefaultPackageCol = (props: DefaultPackageColProps) => {
  /*-----------------------------
   *          CONSTANTS
   * ----------------------------*/

  const hasBundle = props.bundles.find((bundle) => {
    return (
      bundle.extraInfo.subService.productSettingId ===
      props.pkg.productSettingId
    );
  });
  const selectionPillStyle =
    props.selectedId === props.pkg.productSettingId
      ? "default_package__selected_pill"
      : "";
  const selectionBoxStyle =
    props.selectedId === props.pkg.productSettingId
      ? "default_package__selected_box"
      : "";
  const selectionTextStyle =
    props.selectedId === props.pkg.productSettingId
      ? "default_package__selected_text"
      : "";
  const customClass =
    props.language === "en"
      ? "default_package__duration_pill"
      : "default_package__duration_pill_ar";

  return (
    <div
      className={`vas-col-4 default_package__padding0 default_package__relative_pos`}
    >
      <div className={`${customClass} ${selectionPillStyle}`}>
        {props.pkg?.service?.toLowerCase() === "bumpup"
          ? `${props.pkg.quantity} ${props.pkg.durationName}`
          : props.pkg?.service?.toLowerCase().includes("membership") ||
            props.pkg?.service?.toLowerCase().includes("probuyer")
          ? `${Math.floor(props.pkg.duration / 30)} ${props.pkg.unitLabel}`
          : `${props.pkg.duration} ${props.pkg.durationName}`}
      </div>
      <button
        onClick={() => {
          props.setSelectedId(props.pkg.productSettingId);
        }}
        className={`vas content default_package__relative_container default_package__package_button`}
      >
        <div
          className={`default_package__product_box ${selectionBoxStyle} default_package__vertical_alignment vas-align-content-center`}
        >
          <div className={`vas-row default_package__full_height`}>
            <div className={`vas-col default_package__content_col `}>
              {!hasBundle ? (
                <div className={`vas-mt-auto`}>
                  <div
                    className={`default_package__product_price ${selectionTextStyle} default_package__font_size_xl`}
                  >
                    {!props.pkg.promotion.hasPromotion &&
                    Number(props.pkg.promotion.discount) > 0 ? (
                      ""
                    ) : (
                      <div className={``}>
                        <p
                          className={`vas default_package__font_size_md vas-mb-0 default_package__discount`}
                        >
                          {props.pkg.promotion.discount}
                        </p>
                        <p
                          className={`vas default_package__font_size_md vas-mt-0 vas-mb-0 default_package__greyed_text_discount`}
                        >
                          {props.pkg.promotion.oldCountryUnitPrice}
                        </p>
                      </div>
                    )}
                    {props.pkg.countryUnitPrice.toFixed(2)}
                  </div>
                  <div
                    className={`default_package__font_size_md ${selectionTextStyle}`}
                  >
                    {props.pkg?.service?.toLowerCase().includes("probuyer")
                      ? props.pkg.countryCurrency
                      : `${props.pkg.countryCurrency} / ${props.pkg.unitLabel}`}
                  </div>
                </div>
              ) : (
                <div>
                  <div className={`vas-mt-5`}>
                    <div
                      className={`default_package__product_price ${selectionTextStyle} default_package__font_size_xl`}
                    >
                      {hasBundle.availableQuantity}
                      <p
                        className={`vas default_package__font_size_md vas-m-0`}
                      >
                        {t.adsLeft}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={`vas-row vas-justify-content-center vas-mt-auto default_package__padding-bottom8px`}
              >
                <div
                  className={`vas-col-12 default_package__padding0 default_package__buy_now_btn `}
                >
                  <CustomButton
                    confirmationText={props.pkg.confirmationText}
                    showConfirmation={props.pkg.showConfirmation}
                    setIsSuccessProcess={props.setIsSuccessProcess}
                    domain={props.domain}
                    selectedId={
                      props.selectedId === props.pkg.productSettingId &&
                      props.selectedAssignId
                    }
                    api={props.api}
                    token={props.token}
                    countryAbbreviation={props.countryAbbreviation}
                    language={props.language}
                    source={props.source}
                    pos_source={props.pos_source}
                    referral_url={props.referral_url}
                    modelId={props.modelId}
                    productAssignId={props.selectedAssignId}
                    bundleId={props.pkg.bundleId}
                    // bundleId={usedBundle.id}
                    currentBundles={props.currentBundles}
                    isBundle={props.pkg.isBundle}
                    text={
                      props.currentBundles
                        .map((bundle) => {
                          return bundle.extraInfo.subService.productSettingId;
                        })
                        .includes(props.selectedId)
                        ? t.useBundle
                        : t.buyNow
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default DefaultPackageCol;
